React    = require 'react'
Xrespond = require '../scripts/xrespond'

module.exports = DropdownDevice = React.createClass
  handleClick: (e) ->
    @props.handleSubmit Xrespond.device_by_name(@props.name)

  name: ->
    __html: @props.name_marked || @props.name

  render: ->
    subtitle = if @props.subtitle then @props.subtitle else @props.width + ' × ' + @props.height + ' dp'

    React.createElement("li", {"className": "menu-list__item", "onClick": (@handleClick), "onKeyPress": (@handleClick), "tabIndex": "0"},
      React.createElement("div", {"className": "menu-list__title", "dangerouslySetInnerHTML": (@name())}),
      React.createElement("div", {"className": "menu-list__description"}, (subtitle))
    )



// WEBPACK FOOTER //
// ./~/cjsx-loader!./app/js/components/dropdown_device.cjsx